
	import { defineComponent, onMounted, ref, reactive, toRefs } from 'vue'
	import formatDate from '@/common/functions/formatDate'
	import { reviewInfo, review } from '../request'
	import { message } from 'ant-design-vue'
	import Params from './Params.vue'
	import PreviewImage from './PreviewImage.vue'
	export default defineComponent({
		components: {
			Params,
			PreviewImage
		},
		props: {
			detail: {
				type: Object,
				default: () => {}
			}
		},
		emits: ['close', 'success'],
		setup(props, { emit }) {
			const { detail } = toRefs(props)
			const visible = ref(true)
			const afterClose = () => {
				emit('close')
			}
			const form = reactive<any>({})
			const desc = ref('')
			const mobile = ref('')
			const fetchDetail = async () => {
				try {
					const params = {
						id: detail.value.id
					}
					const { data } = await reviewInfo(params)
					Object.assign(form, data)
					if (detail.value.reviewDesc) {
						desc.value = detail.value.reviewDesc
					}
					mobile.value = data.mobile
					if (form.applyInfo) {
						// 如果申请信息存在
						form.info = JSON.parse(form.applyInfo)
					}
				} catch (error) {
					console.log(error)
				}
			}
			const paramsState = reactive({
				visible: false
			})
			//审核通过
			const pass = () => {
				// 短信营销and人工外呼 需要额外参数
				if (form.code === 'duanxin' || form.code === 'rengongwaihu') {
					paramsState.visible = true
				} else {
					passReview('')
				}
			}
			const handleClose = () => {
				paramsState.visible = false
			}
			// 驳回
			const refuse = async () => {
				try {
					if (desc.value) {
						const params = {
							id: form.id,
							isOpen: 0,
							reviewDesc: desc.value
						}
						await review(params)
						message.success('已驳回')
						afterClose()
						emit('success')
					} else {
						message.warn('请先输入审批说明')
					}
				} catch (error) {
					console.log(error)
				}
			}
			const handleSuccess = (value) => {
				passReview(value)
			}
			// 通过审核
			const passReview = async (value) => {
				try {
					const params = {
						id: form.id,
						isOpen: 1,
						configJson: value,
						reviewDesc: desc.value
					}
					await review(params)
					message.success('已审核通过')
					handleClose()
					afterClose()
					emit('success')
				} catch (error) {
					console.log(error)
				}
			}
			onMounted(() => {
				if (detail.value) {
					fetchDetail()
				}
			})
			return {
				visible,
				afterClose,
				form,
				desc,
				pass,
				refuse,
				paramsState,
				handleClose,
				formatDate,
				handleSuccess,
				mobile
			}
		}
	})
